export default function boldTextWithAsterisk(string: string) {
  return (string?.split(/(\*.*?\*)/g).filter((part) => part !== "") ?? []).map(
    (s) => {
      if (s.startsWith("*")) {
        return (
          <span key={s} className="font-bold">
            {s.replaceAll("*", "")}
          </span>
        );
      }
      return s;
    },
  );
}
